import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getVisibleNotificationsHistoric,
  getFilters,
  getPagination,
  getIsLoading,
} from 'notifications_historic/selectors';
import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';

import * as NotificationsHistoric from 'notifications_historic/components';
import NotificationHistoricRowContainer from 'notifications_historic/containers/NotificationHistoricRowContainer';
import NotificationsHistoricListHandlers from 'notifications_historic/containers/NotificationsHistoricListHandlers';

import { toggle } from 'notifications_historic/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

class NotificationsHistoricListContainer extends Component {
  renderRows = () =>
    this.props.notifications_historic.map((notificationHistoric) => (
      <NotificationHistoricRowContainer
        key={notificationHistoric.id}
        notificationHistoric={notificationHistoric}
        handleToggle={this.handleToggle}
      />
    ));

  handleToggle = (id) =>
    this.props
      .toggle(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));

  render = () => (
    <NotificationsHistoricListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
      }) => (
        <NotificationsHistoric.ListView
          count={this.props.notifications_historic.length}
          filters={this.props.filters}
          company={this.props.company}
          handleToggle={this.handleToggle}
          isLoading={this.props.isLoading}
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.renderRows()}
        </NotificationsHistoric.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissions(state),
  notifications_historic: getVisibleNotificationsHistoric(state),
  filters: getFilters(state),
  pagination: getPagination(state),
  isLoading: getIsLoading(state),
});
const mapDispatchToProps = { toggle, error, success };

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsHistoricListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/containers/NotificationsHistoricListContainer.js